import { baseSecondGuaranteApi } from "./baseSecondGuaranteeApis";


interface ApiResponse {
  code: string;
  message: string;
  errors: [];
  data: ClientDetails;
}

interface ClientDetails {
  client_details_id: string;
  loan_application_id: string;
  person_id: string;
  person_type: string;
  regimen: string;
  attempts: number;
  upload_type: string;
}

const metaMapSecondGuarantee = baseSecondGuaranteApi.injectEndpoints({
  endpoints: (build) => ({
    getMetaMapDataSecondGuarantee: build.query<ApiResponse, string>({
      query: (id) => ({
        url: `identity_verification_metamap/metadata/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetMetaMapDataSecondGuaranteeQuery } = metaMapSecondGuarantee;
